import { Component } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseListComponent } from "../base/base-list.component";
import { DatatableClickEvent, DatatableComponent } from '@basis/angular-components';
import { StatusFiltro } from 'app/entity/enumeraveis';

@Component({
  selector: 'gerenciar-permissoes',
  templateUrl: './gerenciar-permissoes.component.html',
})
export class GerenciarPermissoesComponent extends BaseListComponent {
  controllerName = 'usuarioLotacaoPerfil'
  // public filtro: FormGroup
  listaStatus: SelectItem[] = []
  listaLotacao: SelectItem[] = []
  listaSistema: SelectItem[] = []
  listaPerfil: SelectItem[] = []
  filtro = this.formBuilder.group({
    possui: [this.controllerName],
    tipo: [null],
    id_status: [null],
    id_perfis: [null],
    id_sistemas: [null],
    id_lotacoes: [null],
    cpf: [null],
    nome: [null]
  });


  init() {
    
    this.filtro.controls["id_perfis"].disable()
    this.listagem.extraParams = { selectionMode: null };

    this.loadListAsEnum(this.listaStatus, StatusFiltro);

    if (sessionStorage.getItem("msg") !== null) {
      super.showMsg('success', 'Mensagem de Sucesso', sessionStorage.getItem("msg"))
    }
    this.listagem.pDatatableComponent.sortOrder = 2;
    sessionStorage.removeItem("msg");

    this.service.ListarTodos('lotacao').subscribe(data => {
      this.listaLotacao = data
    })

    // this.service.ListarTodos('perfil').subscribe(x => {
    //   this.listaPerfil = x;
    // });

    this.service.ListarTodos('sistema').subscribe(data => {
      this.listaSistema = data
    })

    this.filtro.get("id_sistemas").valueChanges.subscribe(data => {
      if (data != null) {
        this.listaPerfil = []
        this.service.FiltroPerfil(`perfil/filtrarPerfis`, data).subscribe(retorno => {
          this.listaPerfil = retorno
        })
        this.filtro.controls["id_perfis"].enable()
      }
    })
  }

  acao(event: DatatableClickEvent) {
    if (event.button === 'delete_list') {
      this.onButtonClick(event);
    } else {
      const eventoValido = this.validaEvento(event.selection);
      event.selection = event.selection[0]
      return eventoValido ? this.onButtonClick(event) : eventoValido;
    }
  }

  validaEvento(registros: any): boolean {
    if (!registros || registros.length === 0) {
      this.showMsg('warn', 'Mensagem de Alerta', 'Antes de executar esta ação selecione um registro na tabela.');
      return false;
    } else if (registros.length > 1) {
      this.showMsg('warn', 'Mensagem de Alerta', 'É necessário que seja selecionado no máximo um registro para esta ação.');
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/gerenciar-permissoes/gerenciar-permissoes.component.ts